export function parseId(idWithSlug: string) {
  const id = idWithSlug.split("-")[0];
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(id)) return idWithSlug;

  return idWithSlug.split("-")[0];
}
